import { supabase } from "../supabase/client";
import { NotificationSettings } from "@/types";

export const notificationService = {
  /**
   * Получает текущие настройки уведомлений пользователя
   * @returns {Promise<NotificationSettings>} Текущие настройки или настройки по умолчанию
   */
  async getNotificationSettings(): Promise<NotificationSettings> {
    const { data, error } = await supabase.rpc("get_notification_settings");

    if (error) {
      console.error("Ошибка при получении настроек:", error);
      throw error;
    }

    return data;
  },

  /**
   * Обновляет настройки уведомлений пользователя
   * @param {NotificationSettings} settings - Новые настройки уведомлений
   * @returns {Promise<NotificationSettings>} Обновлённые настройки
   */
  async updateNotificationSettings(
    settings: NotificationSettings
  ): Promise<NotificationSettings> {
    const { data, error } = await supabase.rpc("update_notification_settings", {
      new_settings: settings,
    });

    if (error) {
      console.error("Ошибка при обновлении настроек:", error);
      throw error;
    }

    return data;
  },
};
